import PropTypes from 'prop-types'
import { optiDriveScoreComponentsPropType } from './opti-drive-score-components-prop-type'

/**
 * @typedef {Object} OptiDriveScore
 * @property {OptiDriveScoreComponents} [componentScores]   - The individual OptiDrive score components.
 * @property {number}                   [totalScore]        - The total calculated OptiDrive score.
 */

export const optiDriveScorePropType = PropTypes.shape({
    componentScores: optiDriveScoreComponentsPropType,
    totalScore: PropTypes.number
})
